module.exports = __webpack_public_path__ + "img/hr-level2addon_running_gun_mask.54d2d1c9.png";